import { view, lensProp, compose, unless, isNil } from 'ramda'
import * as R from 'ramda'

export const mapToGroupItem = (apiItem) => {
  const memberSubGroups = apiItem.tags.map((result) => result.users.length)
  return {
    id: apiItem.id,
    title: apiItem.name,
    subtitle: R.sum(memberSubGroups),
    avatar: '',
  }
}

export const parseLocation = (location) => {
  return {
    latitude: R.prop('lat', location),
    longitude: R.prop('lng', location),
  }
}

/** Place -> MapLocation { lat: Number, lng: Number } */
export const mapLocation = compose(
  unless(isNil, (location) => ({
    lat: location.latitude,
    lng: location.longitude,
  })),
  view(lensProp('info')), // Place -> Location
)
